import Vue from 'vue';
import Vuex from 'vuex';

import Ui from './Ui';
import User from './User';
import CompanySettings from './CompanySettings';
import Surveys from './Surveys';
import MentorshipGroups from './MentorshipGroups';
import Logger from './Logger';
import VideoMeetings from './VideoMeetings';
import Experts from './Experts';
import CompanyPrograms from './CompanyPrograms';
import Support from './Support';
import Programs from './Programs';
import ContentMedia from './ContentMedia';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Ui,
    User,
    CompanySettings,
    Surveys,
    MentorshipGroups,
    Logger,
    VideoMeetings,
    Experts,
    CompanyPrograms,
    Support,
    Programs,
    ContentMedia,
  },
});


export default store;
